import React, { useMemo } from 'react';
import { cn } from '@/lib/utils';
import { ClientBasicInfoForm } from '../client_configuration/ClientBasicInfoForm';
import type { Tables } from '@/integrations/supabase/types';
import type { ClientFormData } from '../new_client/utilities/formDataUtils';
import type { Role } from '@/types/Role';
import type { RateMultiplier } from '@/types/RateMultiplier';

// Subset of ClientFullConfigData relevant to this component
type ClientSettingsData = Partial<Tables<'client_configuration'>>;

interface ClientSettingsProps {
  clientData: ClientSettingsData;
  onUpdate: (updates: Partial<ClientSettingsData>) => void;
  isLoading?: boolean;
  className?: string;
}

const ClientSettings: React.FC<ClientSettingsProps> = ({
  clientData,
  onUpdate,
  isLoading = false,
  className,
}) => {
  // Transform database data to form-ready data
  const formReadyData: ClientFormData = useMemo(() => {
    return {
      ...clientData,
      roles: (Array.isArray(clientData.roles) ? clientData.roles : []) as Role[],
      rate_multipliers: (Array.isArray(clientData.rate_multipliers) ? clientData.rate_multipliers : []) as RateMultiplier[],
    } as ClientFormData;
  }, [clientData]);

  const handleUpdate = (
    field: keyof ClientFormData,
    value: ClientFormData[keyof ClientFormData],
  ) => {
    onUpdate({ [field]: value });
  };

  return (
    <div className={cn("space-y-6", className)}>
      {/* Section 1: Basic Information */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-foreground">Basic Information</h3>
        <ClientBasicInfoForm
          formData={formReadyData}
          onUpdate={handleUpdate}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default ClientSettings;
